import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './PageHeader.css';

const cx = classnames.bind(styles);

function PageHeader({className, desktopImageUrl, mobileImageUrl, title, description}) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <div className={classes}>
            <div className={styles.wrapper}>
                <h1 className={styles.title}>{title}</h1>
                <p className={styles.description}>{description}</p>
            </div>
            <div
                className={styles.backgroundImage}
                style={{
                    ['--desktop-bg-image']: `url(${desktopImageUrl})`,
                    ['--mobile-bg-image']: `url(${mobileImageUrl})`
                }}
            />
        </div>
    )
};

PageHeader.propTypes = {
    className: PropTypes.string,
    desktopImageUrl: PropTypes.string.isRequired,
    mobileImageUrl: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
};

PageHeader.defaultProps = {
    className: ''
};

export {
    PageHeader
};
